<template>
  <div class="main">
    <div v-if="project" class="container">
      <div class="header">
        <router-link :to="{name: 'manage'}">
          <el-button type="primary" class="back-button" icon="el-icon-back"></el-button>
        </router-link>
        <el-button v-on:click="shareProject" type="primary" class="share-button" icon="el-icon-share"></el-button>
      </div>
      <div class="content">
        <h2>Wichtelgruppe verwalten</h2>
        <span class="input-label">Name der Wichtelgruppe</span>
        <el-input :disabled="project.finished" v-model="project.name" class="main-input" placeholder="Name der Wichtelgruppe"></el-input>

        <span class="input-label">Maximale Anzahl der Benutzer</span>
        <el-input :disabled="project.finished" type="number" v-model="project.max_users" class="main-input" placeholder="Maximale Anzahl der Benutzer"></el-input>

        <el-button :disabled="project.finished" type="primary" class="create-button" @click="saveProject" round>Speichern</el-button>

        <el-button v-if="!project.finished" type="danger" class="create-button" @click="finishProject" round>Wichtelzuordnung starten</el-button>
        <el-button v-if="project.finished" type="danger" class="create-button" @click="resendMails" round>Wichtelzuordnung erneut senden</el-button>
        <hr>
        <h2 v-if="!project.finished">Benutzer verwalten</h2>
        <div class="grid">
          <el-card v-for="(user, index) in this.project.users" :key="index">
            <div class="user-card">
              <div class="content">
                <span>{{user.firstname}} {{user.lastname}}</span><br>
                <span class="small">{{user.email}}</span>
              </div>
              <div class="bottom">
                <el-button :disabled="project.finished" type="danger" @click="removeUser(user)" round class="button">Löschen</el-button>
              </div>
            </div>
          </el-card>
          <el-card v-if="!project.finished && (!project.users || project.users.length < project.max_users)">
            <div class="user-card">
              <div class="content">
                <b><span>Wichtel einladen</span></b><br>
                <el-input type="email" v-model="inviteMail" placeholder="E-Mail des Wichtels"></el-input>
              </div>
              <div class="bottom">
                <el-button type="primary" v-on:click="inviteUser" round class="button">Einladen</el-button>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <el-dialog title="Gruppe teilen" :visible.sync="shareDialogVisible">
      <span>Link zum Teilen der Gruppe:</span>
      <p>{{joinLink}}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="shareDialogVisible = false">OK</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import ProjectService from "../services/ProjectService.js";
import ErrorService from "../services/ErrorService.js";

export default {
  name: "EditProject",
  props: {},
  data() {
    return {
      project: {
        name: "",
        max_users: 0,
        email: ""
      },
      inviteMail: "",
      shareDialogVisible: false,
      joinLink: ""
    };
  },
  created() {
    ProjectService.getProjectById(this.$route.params.id).then(project => {
      this.project = project;
      this.joinLink = ProjectService.getJoinLink(project);
    });
  },
  methods: {
    inviteUser() {
      ProjectService.inviteUser(this.inviteMail, this.project)
        .then(response => {})
        .catch(response => {
          this.$notify.error({
            title: "Fehler",
            message: ErrorService.getErrorMsg(response.error)
          });
        });
    },
    removeUser(user) {
      ProjectService.removeUserFromProject(user, this.project).then(project => {
        this.project = project;
      });
    },
    shareProject() {
      this.shareDialogVisible = true;
    },
    saveProject() {
      ProjectService.updateProject(this.project).then(project => {
        this.project = project;
      });
    },
    finishProject() {
      ProjectService.finishProject(this.project)
        .then(finishedProject => {
          this.project = finishedProject;
          this.$notify({
            title: "Erfolgreich",
            message: `🎅 Super, es hat alles geklappt. Jeder Benutzer der Gruppe hat eine E-Mail mit seinem Wichtelpartner bekommen.
            Viel Spaß beim Wichteln 🎅`,
            duration: 0,
            type: "success"
          });
        })
        .catch(error => {});
    },
    resendMails() {
      ProjectService.resendMails(this.project)
        .then(project => {
          this.$notify({
            title: "Erfolgreich",
            message: `🎅 Die Wichtelmails wurden erneut an alle Benutzer gesendet. 🎅`,
            type: "success"
          });
        })
        .catch(error => {});
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .container {
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .el-dialog {
    p {
      word-break: break-word;
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    grid-gap: 20px;
    align-items: stretch;
    width: 100%;

    .user-card {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }

    .bottom {
      display: flex;
      justify-content: space-around;
      margin-top: 15px;
    }
  }
  .grid > .el-card {
    border: 1px solid #ccc;
    box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.4);
    margin-bottom: 15px;

    span.small {
      font-size: 12px;
    }

    .el-input {
      width: 250px;
    }
  }

  /deep/ .el-card__body {
    height: 75%;
  }

  hr {
    width: 100%;
  }

  .main-input {
    width: 300px;
  }

  .input-label {
    margin-top: 20px;
  }

  .create-button {
    margin-top: 25px;
    min-height: 40px;
  }
}
</style>
